import { ProductSpecificationAttributes, ProductCategoryProduct } from '@/types'
import { CreateProductSpecificationMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'

interface Props {
  onSuccess: () => void
  defaultValues: Partial<ProductSpecificationAttributes>
}

export const Form = ({ onSuccess, defaultValues }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading
  } = useForm<CreateProductSpecificationMutation, ProductSpecificationAttributes, never, never>({
    defaultValues: {
      specification: '',
      productId: '',
      productType: ProductCategoryProduct.AssetType,
      value: '',
      ...defaultValues
    },
    mutation: CreateMutation,
    resultKey: 'createProductSpecification',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Specification', field: 'specification', type: 'specification' }) }
      { formBuilder.buildField({ name: 'Value', field: 'value', type: 'text' }) }
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
